/** CPU culling must use the headset union projection supplied by WebXRManager. */
export function preserveXRFov(world: { updateSmoothFov: () => void }, presenting: () => boolean) {
  const original = world.updateSmoothFov
  world.updateSmoothFov = function () { if (!presenting()) original.call(world) }
  return () => { world.updateSmoothFov = original }
}
